export default __webpack_public_path__ + "static/media/bb.ec6cc0cb.png";